// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true,valid_types=protovalidate_required"
// @generated from file proto/v1/job_types.proto (package vmspdb.api.proto.v1, syntax proto3)
/* eslint-disable */

// buf:lint:ignore PACKAGE_DIRECTORY_MATCH

import type { Message } from '@bufbuild/protobuf';
import type {
  GenEnum,
  GenFile,
  GenMessage,
  GenService,
} from '@bufbuild/protobuf/codegenv2';
import {
  enumDesc,
  fileDesc,
  messageDesc,
  serviceDesc,
} from '@bufbuild/protobuf/codegenv2';
import type { Timestamp, TimestampJson } from '@bufbuild/protobuf/wkt';
import { file_google_protobuf_timestamp } from '@bufbuild/protobuf/wkt';
import { file_buf_validate_validate } from '../../buf/validate/validate_pb';
import { file_proto_v1_extension_enum } from './extension_enum_pb';
import type {
  AuditUpdater,
  AuditUpdaterJson,
  Pagination,
  PaginationJson,
  SortDirection,
  SortDirectionJson,
} from './type_common_pb';
import { file_proto_v1_type_common } from './type_common_pb';

/**
 * Describes the file proto/v1/job_types.proto.
 */
export const file_proto_v1_job_types: GenFile =
  /*@__PURE__*/
  fileDesc(
    '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',
    [
      file_buf_validate_validate,
      file_google_protobuf_timestamp,
      file_proto_v1_extension_enum,
      file_proto_v1_type_common,
    ],
  );

/**
 * @generated from message vmspdb.api.proto.v1.JobTypeOptions
 */
export type JobTypeOptions = Message<'vmspdb.api.proto.v1.JobTypeOptions'> & {
  /**
   * @generated from field: bool house_plan = 1;
   */
  housePlan: boolean;

  /**
   * @generated from field: bool permits = 2;
   */
  permits: boolean;

  /**
   * @generated from field: bool survey_notifications = 3;
   */
  surveyNotifications: boolean;
};

/**
 * @generated from message vmspdb.api.proto.v1.JobTypeOptions
 */
export type JobTypeOptionsJson = {
  /**
   * @generated from field: bool house_plan = 1;
   */
  housePlan?: boolean;

  /**
   * @generated from field: bool permits = 2;
   */
  permits?: boolean;

  /**
   * @generated from field: bool survey_notifications = 3;
   */
  surveyNotifications?: boolean;
};

export type JobTypeOptionsValid = JobTypeOptions;

/**
 * Describes the message vmspdb.api.proto.v1.JobTypeOptions.
 * Use `create(JobTypeOptionsSchema)` to create a new message.
 */
export const JobTypeOptionsSchema: GenMessage<
  JobTypeOptions,
  { jsonType: JobTypeOptionsJson; validType: JobTypeOptionsValid }
> = /*@__PURE__*/ messageDesc(file_proto_v1_job_types, 0);

/**
 * @generated from message vmspdb.api.proto.v1.JobTypeServiceGetResponse
 */
export type JobTypeServiceGetResponse =
  Message<'vmspdb.api.proto.v1.JobTypeServiceGetResponse'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;

    /**
     * @generated from field: string name = 2;
     */
    name: string;

    /**
     * @generated from field: string description = 3;
     */
    description: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.JobTypeOptions options = 4;
     */
    options?: JobTypeOptions;

    /**
     * @generated from field: bool major = 5;
     */
    major: boolean;

    /**
     * @generated from field: string long_description = 6;
     */
    longDescription: string;

    /**
     * @generated from field: google.protobuf.Timestamp created_at = 29;
     */
    createdAt?: Timestamp;

    /**
     * @generated from field: google.protobuf.Timestamp updated_at = 30;
     */
    updatedAt?: Timestamp;

    /**
     * @generated from field: vmspdb.api.proto.v1.AuditUpdater updater = 31;
     */
    updater?: AuditUpdater;
  };

/**
 * @generated from message vmspdb.api.proto.v1.JobTypeServiceGetResponse
 */
export type JobTypeServiceGetResponseJson = {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid?: string;

  /**
   * @generated from field: string name = 2;
   */
  name?: string;

  /**
   * @generated from field: string description = 3;
   */
  description?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.JobTypeOptions options = 4;
   */
  options?: JobTypeOptionsJson;

  /**
   * @generated from field: bool major = 5;
   */
  major?: boolean;

  /**
   * @generated from field: string long_description = 6;
   */
  longDescription?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 29;
   */
  createdAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 30;
   */
  updatedAt?: TimestampJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.AuditUpdater updater = 31;
   */
  updater?: AuditUpdaterJson;
};

export type JobTypeServiceGetResponseValid = JobTypeServiceGetResponse;

/**
 * Describes the message vmspdb.api.proto.v1.JobTypeServiceGetResponse.
 * Use `create(JobTypeServiceGetResponseSchema)` to create a new message.
 */
export const JobTypeServiceGetResponseSchema: GenMessage<
  JobTypeServiceGetResponse,
  {
    jsonType: JobTypeServiceGetResponseJson;
    validType: JobTypeServiceGetResponseValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_job_types, 1);

/**
 * @generated from message vmspdb.api.proto.v1.JobTypeServiceGetRequest
 */
export type JobTypeServiceGetRequest =
  Message<'vmspdb.api.proto.v1.JobTypeServiceGetRequest'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;
  };

/**
 * @generated from message vmspdb.api.proto.v1.JobTypeServiceGetRequest
 */
export type JobTypeServiceGetRequestJson = {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid?: string;
};

/**
 * @generated from message vmspdb.api.proto.v1.JobTypeServiceGetRequest
 */
export type JobTypeServiceGetRequestValid =
  Message<'vmspdb.api.proto.v1.JobTypeServiceGetRequest'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;
  };

/**
 * Describes the message vmspdb.api.proto.v1.JobTypeServiceGetRequest.
 * Use `create(JobTypeServiceGetRequestSchema)` to create a new message.
 */
export const JobTypeServiceGetRequestSchema: GenMessage<
  JobTypeServiceGetRequest,
  {
    jsonType: JobTypeServiceGetRequestJson;
    validType: JobTypeServiceGetRequestValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_job_types, 2);

/**
 * @generated from message vmspdb.api.proto.v1.JobTypeServiceCreateRequest
 */
export type JobTypeServiceCreateRequest =
  Message<'vmspdb.api.proto.v1.JobTypeServiceCreateRequest'> & {
    /**
     * @generated from field: string name = 1;
     */
    name: string;

    /**
     * @generated from field: string description = 2;
     */
    description: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.JobTypeOptions options = 3;
     */
    options?: JobTypeOptions;

    /**
     * @generated from field: bool major = 4;
     */
    major: boolean;

    /**
     * @generated from field: string long_description = 5;
     */
    longDescription: string;
  };

/**
 * @generated from message vmspdb.api.proto.v1.JobTypeServiceCreateRequest
 */
export type JobTypeServiceCreateRequestJson = {
  /**
   * @generated from field: string name = 1;
   */
  name?: string;

  /**
   * @generated from field: string description = 2;
   */
  description?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.JobTypeOptions options = 3;
   */
  options?: JobTypeOptionsJson;

  /**
   * @generated from field: bool major = 4;
   */
  major?: boolean;

  /**
   * @generated from field: string long_description = 5;
   */
  longDescription?: string;
};

/**
 * @generated from message vmspdb.api.proto.v1.JobTypeServiceCreateRequest
 */
export type JobTypeServiceCreateRequestValid =
  Message<'vmspdb.api.proto.v1.JobTypeServiceCreateRequest'> & {
    /**
     * @generated from field: string name = 1;
     */
    name: string;

    /**
     * @generated from field: string description = 2;
     */
    description: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.JobTypeOptions options = 3;
     */
    options?: JobTypeOptionsValid;

    /**
     * @generated from field: bool major = 4;
     */
    major: boolean;

    /**
     * @generated from field: string long_description = 5;
     */
    longDescription: string;
  };

/**
 * Describes the message vmspdb.api.proto.v1.JobTypeServiceCreateRequest.
 * Use `create(JobTypeServiceCreateRequestSchema)` to create a new message.
 */
export const JobTypeServiceCreateRequestSchema: GenMessage<
  JobTypeServiceCreateRequest,
  {
    jsonType: JobTypeServiceCreateRequestJson;
    validType: JobTypeServiceCreateRequestValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_job_types, 3);

/**
 * @generated from message vmspdb.api.proto.v1.JobTypeServiceCreateResponse
 */
export type JobTypeServiceCreateResponse =
  Message<'vmspdb.api.proto.v1.JobTypeServiceCreateResponse'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;

    /**
     * @generated from field: string name = 2;
     */
    name: string;

    /**
     * @generated from field: string description = 3;
     */
    description: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.JobTypeOptions options = 4;
     */
    options?: JobTypeOptions;

    /**
     * @generated from field: bool major = 5;
     */
    major: boolean;

    /**
     * @generated from field: string long_description = 6;
     */
    longDescription: string;

    /**
     * @generated from field: google.protobuf.Timestamp created_at = 29;
     */
    createdAt?: Timestamp;

    /**
     * @generated from field: google.protobuf.Timestamp updated_at = 30;
     */
    updatedAt?: Timestamp;

    /**
     * @generated from field: vmspdb.api.proto.v1.AuditUpdater updater = 31;
     */
    updater?: AuditUpdater;
  };

/**
 * @generated from message vmspdb.api.proto.v1.JobTypeServiceCreateResponse
 */
export type JobTypeServiceCreateResponseJson = {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid?: string;

  /**
   * @generated from field: string name = 2;
   */
  name?: string;

  /**
   * @generated from field: string description = 3;
   */
  description?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.JobTypeOptions options = 4;
   */
  options?: JobTypeOptionsJson;

  /**
   * @generated from field: bool major = 5;
   */
  major?: boolean;

  /**
   * @generated from field: string long_description = 6;
   */
  longDescription?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 29;
   */
  createdAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 30;
   */
  updatedAt?: TimestampJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.AuditUpdater updater = 31;
   */
  updater?: AuditUpdaterJson;
};

export type JobTypeServiceCreateResponseValid = JobTypeServiceCreateResponse;

/**
 * Describes the message vmspdb.api.proto.v1.JobTypeServiceCreateResponse.
 * Use `create(JobTypeServiceCreateResponseSchema)` to create a new message.
 */
export const JobTypeServiceCreateResponseSchema: GenMessage<
  JobTypeServiceCreateResponse,
  {
    jsonType: JobTypeServiceCreateResponseJson;
    validType: JobTypeServiceCreateResponseValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_job_types, 4);

/**
 * @generated from message vmspdb.api.proto.v1.JobTypeServiceListRequest
 */
export type JobTypeServiceListRequest =
  Message<'vmspdb.api.proto.v1.JobTypeServiceListRequest'> & {
    /**
     * @generated from field: string filter = 1;
     */
    filter: string;

    /**
     * @generated from field: uint32 page_index = 2;
     */
    pageIndex: number;

    /**
     * @generated from field: uint32 page_size = 3;
     */
    pageSize: number;

    /**
     * @generated from field: vmspdb.api.proto.v1.SortDirection sort_direction = 4;
     */
    sortDirection: SortDirection;

    /**
     * @generated from field: string sort_field = 5 [deprecated = true];
     * @deprecated
     */
    sortField: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.JobTypeSort sort = 6;
     */
    sort: JobTypeSort;
  };

/**
 * @generated from message vmspdb.api.proto.v1.JobTypeServiceListRequest
 */
export type JobTypeServiceListRequestJson = {
  /**
   * @generated from field: string filter = 1;
   */
  filter?: string;

  /**
   * @generated from field: uint32 page_index = 2;
   */
  pageIndex?: number;

  /**
   * @generated from field: uint32 page_size = 3;
   */
  pageSize?: number;

  /**
   * @generated from field: vmspdb.api.proto.v1.SortDirection sort_direction = 4;
   */
  sortDirection?: SortDirectionJson;

  /**
   * @generated from field: string sort_field = 5 [deprecated = true];
   * @deprecated
   */
  sortField?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.JobTypeSort sort = 6;
   */
  sort?: JobTypeSortJson;
};

export type JobTypeServiceListRequestValid = JobTypeServiceListRequest;

/**
 * Describes the message vmspdb.api.proto.v1.JobTypeServiceListRequest.
 * Use `create(JobTypeServiceListRequestSchema)` to create a new message.
 */
export const JobTypeServiceListRequestSchema: GenMessage<
  JobTypeServiceListRequest,
  {
    jsonType: JobTypeServiceListRequestJson;
    validType: JobTypeServiceListRequestValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_job_types, 5);

/**
 * @generated from message vmspdb.api.proto.v1.JobTypeServiceListResponse
 */
export type JobTypeServiceListResponse =
  Message<'vmspdb.api.proto.v1.JobTypeServiceListResponse'> & {
    /**
     * @generated from field: repeated vmspdb.api.proto.v1.JobTypeServiceCreateResponse items = 1;
     */
    items: JobTypeServiceCreateResponse[];

    /**
     * @generated from field: vmspdb.api.proto.v1.Pagination pagination = 2;
     */
    pagination?: Pagination;

    /**
     * @generated from field: bool degraded = 3;
     */
    degraded: boolean;
  };

/**
 * @generated from message vmspdb.api.proto.v1.JobTypeServiceListResponse
 */
export type JobTypeServiceListResponseJson = {
  /**
   * @generated from field: repeated vmspdb.api.proto.v1.JobTypeServiceCreateResponse items = 1;
   */
  items?: JobTypeServiceCreateResponseJson[];

  /**
   * @generated from field: vmspdb.api.proto.v1.Pagination pagination = 2;
   */
  pagination?: PaginationJson;

  /**
   * @generated from field: bool degraded = 3;
   */
  degraded?: boolean;
};

export type JobTypeServiceListResponseValid = JobTypeServiceListResponse;

/**
 * Describes the message vmspdb.api.proto.v1.JobTypeServiceListResponse.
 * Use `create(JobTypeServiceListResponseSchema)` to create a new message.
 */
export const JobTypeServiceListResponseSchema: GenMessage<
  JobTypeServiceListResponse,
  {
    jsonType: JobTypeServiceListResponseJson;
    validType: JobTypeServiceListResponseValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_job_types, 6);

/**
 * @generated from message vmspdb.api.proto.v1.JobTypeServiceUpdateRequest
 */
export type JobTypeServiceUpdateRequest =
  Message<'vmspdb.api.proto.v1.JobTypeServiceUpdateRequest'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;

    /**
     * @generated from field: string name = 2;
     */
    name: string;

    /**
     * @generated from field: string description = 3;
     */
    description: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.JobTypeOptions options = 4;
     */
    options?: JobTypeOptions;

    /**
     * @generated from field: bool major = 5;
     */
    major: boolean;

    /**
     * @generated from field: string long_description = 6;
     */
    longDescription: string;
  };

/**
 * @generated from message vmspdb.api.proto.v1.JobTypeServiceUpdateRequest
 */
export type JobTypeServiceUpdateRequestJson = {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid?: string;

  /**
   * @generated from field: string name = 2;
   */
  name?: string;

  /**
   * @generated from field: string description = 3;
   */
  description?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.JobTypeOptions options = 4;
   */
  options?: JobTypeOptionsJson;

  /**
   * @generated from field: bool major = 5;
   */
  major?: boolean;

  /**
   * @generated from field: string long_description = 6;
   */
  longDescription?: string;
};

/**
 * @generated from message vmspdb.api.proto.v1.JobTypeServiceUpdateRequest
 */
export type JobTypeServiceUpdateRequestValid =
  Message<'vmspdb.api.proto.v1.JobTypeServiceUpdateRequest'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;

    /**
     * @generated from field: string name = 2;
     */
    name: string;

    /**
     * @generated from field: string description = 3;
     */
    description: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.JobTypeOptions options = 4;
     */
    options?: JobTypeOptionsValid;

    /**
     * @generated from field: bool major = 5;
     */
    major: boolean;

    /**
     * @generated from field: string long_description = 6;
     */
    longDescription: string;
  };

/**
 * Describes the message vmspdb.api.proto.v1.JobTypeServiceUpdateRequest.
 * Use `create(JobTypeServiceUpdateRequestSchema)` to create a new message.
 */
export const JobTypeServiceUpdateRequestSchema: GenMessage<
  JobTypeServiceUpdateRequest,
  {
    jsonType: JobTypeServiceUpdateRequestJson;
    validType: JobTypeServiceUpdateRequestValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_job_types, 7);

/**
 * @generated from message vmspdb.api.proto.v1.JobTypeServiceUpdateResponse
 */
export type JobTypeServiceUpdateResponse =
  Message<'vmspdb.api.proto.v1.JobTypeServiceUpdateResponse'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;

    /**
     * @generated from field: string name = 2;
     */
    name: string;

    /**
     * @generated from field: string description = 3;
     */
    description: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.JobTypeOptions options = 4;
     */
    options?: JobTypeOptions;

    /**
     * @generated from field: bool major = 5;
     */
    major: boolean;

    /**
     * @generated from field: string long_description = 6;
     */
    longDescription: string;

    /**
     * @generated from field: google.protobuf.Timestamp created_at = 29;
     */
    createdAt?: Timestamp;

    /**
     * @generated from field: google.protobuf.Timestamp updated_at = 30;
     */
    updatedAt?: Timestamp;

    /**
     * @generated from field: vmspdb.api.proto.v1.AuditUpdater updater = 31;
     */
    updater?: AuditUpdater;
  };

/**
 * @generated from message vmspdb.api.proto.v1.JobTypeServiceUpdateResponse
 */
export type JobTypeServiceUpdateResponseJson = {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid?: string;

  /**
   * @generated from field: string name = 2;
   */
  name?: string;

  /**
   * @generated from field: string description = 3;
   */
  description?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.JobTypeOptions options = 4;
   */
  options?: JobTypeOptionsJson;

  /**
   * @generated from field: bool major = 5;
   */
  major?: boolean;

  /**
   * @generated from field: string long_description = 6;
   */
  longDescription?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 29;
   */
  createdAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 30;
   */
  updatedAt?: TimestampJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.AuditUpdater updater = 31;
   */
  updater?: AuditUpdaterJson;
};

export type JobTypeServiceUpdateResponseValid = JobTypeServiceUpdateResponse;

/**
 * Describes the message vmspdb.api.proto.v1.JobTypeServiceUpdateResponse.
 * Use `create(JobTypeServiceUpdateResponseSchema)` to create a new message.
 */
export const JobTypeServiceUpdateResponseSchema: GenMessage<
  JobTypeServiceUpdateResponse,
  {
    jsonType: JobTypeServiceUpdateResponseJson;
    validType: JobTypeServiceUpdateResponseValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_job_types, 8);

/**
 * @generated from message vmspdb.api.proto.v1.JobTypeServiceDeleteRequest
 */
export type JobTypeServiceDeleteRequest =
  Message<'vmspdb.api.proto.v1.JobTypeServiceDeleteRequest'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;
  };

/**
 * @generated from message vmspdb.api.proto.v1.JobTypeServiceDeleteRequest
 */
export type JobTypeServiceDeleteRequestJson = {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid?: string;
};

/**
 * @generated from message vmspdb.api.proto.v1.JobTypeServiceDeleteRequest
 */
export type JobTypeServiceDeleteRequestValid =
  Message<'vmspdb.api.proto.v1.JobTypeServiceDeleteRequest'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;
  };

/**
 * Describes the message vmspdb.api.proto.v1.JobTypeServiceDeleteRequest.
 * Use `create(JobTypeServiceDeleteRequestSchema)` to create a new message.
 */
export const JobTypeServiceDeleteRequestSchema: GenMessage<
  JobTypeServiceDeleteRequest,
  {
    jsonType: JobTypeServiceDeleteRequestJson;
    validType: JobTypeServiceDeleteRequestValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_job_types, 9);

/**
 * @generated from message vmspdb.api.proto.v1.JobTypeServiceDeleteResponse
 */
export type JobTypeServiceDeleteResponse =
  Message<'vmspdb.api.proto.v1.JobTypeServiceDeleteResponse'> & {};

/**
 * @generated from message vmspdb.api.proto.v1.JobTypeServiceDeleteResponse
 */
export type JobTypeServiceDeleteResponseJson = {};

export type JobTypeServiceDeleteResponseValid = JobTypeServiceDeleteResponse;

/**
 * Describes the message vmspdb.api.proto.v1.JobTypeServiceDeleteResponse.
 * Use `create(JobTypeServiceDeleteResponseSchema)` to create a new message.
 */
export const JobTypeServiceDeleteResponseSchema: GenMessage<
  JobTypeServiceDeleteResponse,
  {
    jsonType: JobTypeServiceDeleteResponseJson;
    validType: JobTypeServiceDeleteResponseValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_job_types, 10);

/**
 * @generated from enum vmspdb.api.proto.v1.JobTypeSort
 */
export enum JobTypeSort {
  /**
   * @generated from enum value: JOB_TYPE_SORT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: JOB_TYPE_SORT_NAME = 1;
   */
  NAME = 1,
}

/**
 * @generated from enum vmspdb.api.proto.v1.JobTypeSort
 */
export type JobTypeSortJson =
  'JOB_TYPE_SORT_UNSPECIFIED' | 'JOB_TYPE_SORT_NAME';

/**
 * Describes the enum vmspdb.api.proto.v1.JobTypeSort.
 */
export const JobTypeSortSchema: GenEnum<JobTypeSort, JobTypeSortJson> =
  /*@__PURE__*/
  enumDesc(file_proto_v1_job_types, 0);

/**
 * @generated from service vmspdb.api.proto.v1.JobTypeService
 */
export const JobTypeService: GenService<{
  /**
   * @generated from rpc vmspdb.api.proto.v1.JobTypeService.Create
   */
  create: {
    methodKind: 'unary';
    input: typeof JobTypeServiceCreateRequestSchema;
    output: typeof JobTypeServiceCreateResponseSchema;
  };
  /**
   * @generated from rpc vmspdb.api.proto.v1.JobTypeService.Get
   */
  get: {
    methodKind: 'unary';
    input: typeof JobTypeServiceGetRequestSchema;
    output: typeof JobTypeServiceGetResponseSchema;
  };
  /**
   * @generated from rpc vmspdb.api.proto.v1.JobTypeService.Delete
   */
  delete: {
    methodKind: 'unary';
    input: typeof JobTypeServiceDeleteRequestSchema;
    output: typeof JobTypeServiceDeleteResponseSchema;
  };
  /**
   * @generated from rpc vmspdb.api.proto.v1.JobTypeService.Update
   */
  update: {
    methodKind: 'unary';
    input: typeof JobTypeServiceUpdateRequestSchema;
    output: typeof JobTypeServiceUpdateResponseSchema;
  };
  /**
   * @generated from rpc vmspdb.api.proto.v1.JobTypeService.List
   */
  list: {
    methodKind: 'unary';
    input: typeof JobTypeServiceListRequestSchema;
    output: typeof JobTypeServiceListResponseSchema;
  };
}> = /*@__PURE__*/ serviceDesc(file_proto_v1_job_types, 0);
